import { IconContainer, ToastWrapper } from './styles'

import { Button } from 'components/v2/Button'
import { Row } from 'components/v2/Grid'
import { Close } from 'components/v2/Icons/assets'
import { Text } from 'components/v2/Text'

const Toast = ({ handleModal, closeToast }) => {
	return (
		<ToastWrapper>
			<Row className='mb-[10px] justify-between'>
				<Text className='font-semibold'>Experimente o Vittude Match!</Text>
				<IconContainer onClick={closeToast}>
					<Close size={14} />
				</IconContainer>
			</Row>
			<Row>
				<Text className='text-sm'>
					O Vittude Match é uma ferramenta que utiliza inteligência artificial
					para ajudar você a encontrar o psicólogo ideal.
				</Text>
			</Row>
			<Row>
				<Button variant='tertiary' className='p-0' onClick={() => handleModal(true)}>
					Iniciar
				</Button>
			</Row>
		</ToastWrapper>
	)
}

export default Toast
